module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Weight2-2f8f3bb0318b51fa66b3ffcb215f133e.svg";